import { LegalDocumentView } from '../components/legal/LegalDocumentView';
import { AGE_SUITABILITY_CONTENT } from '../content/age-suitability';
import { usePageSeo } from '../hooks/usePageSeo';
import { PAGE_SEO } from '../lib/seo';

export function AgeSuitabilityPage() {
  usePageSeo(PAGE_SEO.ageSuitability);

  return <LegalDocumentView document={AGE_SUITABILITY_CONTENT} />;
}
